export default ['arType', 'arTaxRule', 'arCrDrType'];
